import { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Button, Modal, Form, Input } from "antd";
import { showAppMessage, requireAuth, showAppModal } from "~/redux/actions/app";
import { applyTalentPost, checkUser } from "~/redux/actions/talent";
import settings from "~/settings";

const { TextArea } = Input;
const PostTalentAddon = (props) => {
  const [applying, setApplying] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [loadingUserResult, setLoadingUserResult] = useState(false);
  const [reason, setReason] = useState("");
  const [answer, setAnswer] = useState("");
  const isJobsChannel = props.post.category.code === "jobs_channel";

  const showApplyConfirmModal = () => {
    if (isJobsChannel && props.post.closed) {
      Modal.info({
        title: "该职位已结束招聘",
        content: "该职位已经结束招聘，再去看看其他职位吧！",
      });
      return;
    }
    setAnswer("");
    setReason("");
    setApplying(false);
    setModalVisible(true);
  };

  const handleApply = () => {
    if (props.opening && props.opening.question && !answer.trim()) {
      props.showAppMessage("请输入雇主问题的答案", "info");
      return;
    }
    setApplying(true);

    props
      .applyTalentPost(props.token, props.post.id, reason, answer, "web")
      .then(() => {
        // 申请成功
        setApplying(false);
        setModalVisible(false);
      })
      .catch(() => {
        // 申请失败
        setApplying(false);
      });
  };

  const showGoToTalentModel = () => {
    Modal.confirm({
      title: !props.checkUserResult.completed
        ? "请先前往远程人才库完善简历基本信息"
        : props.checkUserResult.proportion < props.checkUserResult.required &&
          `简历完成度${props.checkUserResult.required}%以上才可进行职位申请操作，您现在的完成度为${props.checkUserResult.proportion}%，请先前往远程人才库完善简历信息。`,
      onOk() {
        window.location.href = `${settings.talentUrl}/me/profile?pid=${props.post.id}`;
      },
      onCancel() {},
    });
  };

  useEffect(() => {
    if (props.token) {
      setLoadingUserResult(true);
      props.checkUser(props.token, props.post.id, () => {
        setLoadingUserResult(false);
      });
    }
  }, [props.token]);

  return (
    <div className="text-center py-20 mb-5">
      {!props.checkUserResult.applied || !props.token ? (
        <Button
          type="primary"
          loading={applying || loadingUserResult}
          onClick={() => {
            if (props.token) {
              if (
                props.checkUserResult.detailed &&
                props.checkUserResult.completed &&
                props.checkUserResult.proportion >=
                  props.checkUserResult.required
              ) {
                showApplyConfirmModal();
              } else {
                showGoToTalentModel();
              }
            } else {
              props.showAppModal("PhoneSigninModal");
            }
          }}
        >
          {loadingUserResult ? "检查中..." : "申请该职位"}
        </Button>
      ) : (
        <Button
          type="primary"
          disabled
        >
          您已申请过该职位
        </Button>
      )}
      <Modal
        title="确认申请该职位吗？"
        open={modalVisible}
        width={700}
        confirmLoading={applying}
        onCancel={() => setModalVisible(false)}
        onOk={handleApply}
      >
        <Form layout="vertical">
          <Form.Item label="申请理由">
            <TextArea
              placeholder="你可以在这里如求职信一样，填写自己的附加求职信息（选填）"
              value={reason}
              onChange={(e) => {
                setReason(e.target.value);
              }}
              rows={5}
            />
          </Form.Item>
          {props.opening && props.opening.question && (
            <Form.Item
              label={`雇主问题：${props.opening.question}`}
              required
              labelAlign="left"
              className="mt-10"
            >
              <TextArea
                placeholder="雇主问题是雇主向您询问的问题，请根据自身情况如实填写"
                value={answer}
                onChange={(e) => {
                  setAnswer(e.target.value);
                }}
                rows={5}
              />
            </Form.Item>
          )}
          <Form.Item>
            {isJobsChannel && (
              <div className="text-left font-14">
                * 请注意：不要在求职信中填写任何联系方式，以免被滥用。
              </div>
            )}
            <div className="text-left font-14">
              *
              请务必仔细核对岗位要求再投递简历。若因盲目投递（"乱投"）被多次投诉，可能影响您申请其他岗位的资格。
            </div>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  talent: state.talent,
  checkUserResult: state.talent.checkUserResult,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showAppMessage,
      requireAuth,
      showAppModal,
      applyTalentPost,
      checkUser,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PostTalentAddon);
